import { Brand } from "./Style";
import { style } from "./StyleType";

interface TmpBrandingCustomProps {
    logo: React.ReactNode;
}

export default function TmpBrandingCustom(props: TmpBrandingCustomProps) {

  // Passing style props to styled component
  Brand.defaultProps = style

  return (
    <Brand className="tmp-branding">
      {props.logo}
    </Brand>
  )

}